export const productHeaderPremiumGql = /* GraphQL */ `
... on bodyContent2022_headerPremium_BlockType {
    typeHandle
    sectionTitle
    description
    heightOverride
    heightOverrideMobile
    links:bcProductHeaderPremiumLinks {
        ... on bcProductHeaderPremiumLinks_BlockType {
            linkStyle:bcProductHeaderPremiumLinkLinkStyle
            enableModal:bcProductHeaderPremiumLinksEnableModal
            disclaimerFootnote:bcProductHeaderPremiumLinksDisclaimerFootnote {
                ... on disclaimerFootnote_disclaimerFootnote_Entry {
                    content:disclaimercontent
                }
            }
            link:bcProductHeaderPremiumLink {
                ariaLabel
                customText
                url
                target
                text
                element {
                    title
                    ... on videos_Asset {
                        videoId
                        videoSource
                    }
                    ... on videoUploads_Asset {
                        videoUrl:url
                    }
                }
            }
        }
    }
    media {
        ... on images_Asset {
            __typename
            title
            uncropped1920w {
                srcset
                srcWebp
            }
        }
        ... on videoUploads_Asset {
            __typename
            url
            videoThumbnail {
                ... on images_Asset {
                    uncropped1920w {
                        srcWebp
                        srcset
                    }
                }
            }
        }
    }
}`;
